export enum DeploymentStatus {
  pending = 'pending',
  in_progress = 'in_progress',
  completed = 'completed',
  failed = 'failed',
  rolling_back = 'rolling_back',
  rolled_back = 'rolled_back',
  roll_back_failed = 'roll_back_failed',
}
